import React from 'react'
import * as T from '../../../components/Table'
import { ControleIlustracaoItem } from './ControleIlustracaoItem'
import { user } from '../../../helpers/user'
import { Button, Flex, Text } from '@chakra-ui/react'
import { useControleIlustracaoContext } from '../../../contexts/ControleIlustracaoProvider'

export const ControleIlustracaoList = () => {
  const { query, mutation } = useControleIlustracaoContext()

  const [checkItemsId, setCheckItemsId] = React.useState([])

  if (!query) return null
  const { isLoading, isRefetching, data } = query

  const onCheckItems = async () => {
    const params = {
      id_tabela: checkItemsId,
      numero_nota: data[0].numero_nota,
      usuario: user.codigo_usuario,
    }

    await mutation.mutateAsync(params)

    if (mutation.isSuccess) {
      setCheckItemsId([])
      query.refetch()
    }
  }

  function handleCheckItem(id) {
    const index = checkItemsId.indexOf(id)

    if (index === -1) {
      setCheckItemsId([...checkItemsId, id])
    } else {
      setCheckItemsId(checkItemsId.filter((item) => item !== id))
    }
  }

  if (isRefetching || isLoading) {
    return (
      <T.Tr>
        <T.TdSkeleton colSpan="10" />
      </T.Tr>
    )
  }

  if (!Array.isArray(data)) {
    return (
      <>
        <Text>Estrutura de dados diferente do esperado</Text>
      </>
    )
  }

  return (
    <>
      <T.Tr>
        <T.Td textAlign="start" px={3} colSpan="10">
          <Flex alignItems="center" justifyContent="end" w="100%" gap={4} _hover={{ bg: 'gray.100', cursor: 'pointer' }}>
            <Button onClick={() => onCheckItems()} isLoading={mutation?.isLoading} colorScheme="blue" size="sm">
              Atualizar itens feitos
            </Button>
          </Flex>
        </T.Td>
      </T.Tr>
      {data?.map((item) => (
        <ControleIlustracaoItem key={item.id_solicitacao} item={item} handleCheckItem={handleCheckItem} />
      ))}
    </>
  )
}
